import { AUTH_LOGOUT } from '../../../../../common/redux/actions/types/authActionTypes';
import {
  GET_MRD_BY_COUNTRY_SUCCESS,
  COPY_HANDLERS_REQUEST,
  COPY_HANDLERS_SUCCESS,
  COPY_HANDLERS_FAILURE,
  EDIT_HANDLERS_REQUEST,
  EDIT_HANDLERS_SUCCESS,
  EDIT_HANDLERS_FAILURE,
  CLEAR_MRD_SELECTION,
  GET_ALL_HANDLERS_SUCCESS,
  GET_HANDLERS_BY_MRD_SUCCESS,
  ASSOCIATE_NEW_HANDLERS_REQUEST,
  ASSOCIATE_NEW_HANDLERS_SUCCESS,
  ASSOCIATE_NEW_HANDLERS_FAILURE,
  GET_HANDLERS_BY_MRD_REQUEST, CREATE_NEW_HANDLER_REQUEST, CREATE_NEW_HANDLER_SUCCESS,
} from '../actions/types/HandlersActionTypes';

export const initialState = {
  mrdDevices: [],
  lastRequestStatus: null,
  selectedMrd: null,
  allHandlers: [],
  handlerListByMrd: [],
  isHandLerListByMrdLoading: false,
  requestHandlerName: '',
  isHandlerPersisted: false,
  persistedHandlerId: null,
};
const HandlersReducer = (state = initialState, action) => {
  switch (action.type) {
  case GET_MRD_BY_COUNTRY_SUCCESS:
    return {
      ...state,
      mrdDevices: action.payload,
    };
  case COPY_HANDLERS_REQUEST:
    return {
      ...state,
      lastRequestStatus: null,
      selectedMrd: action.payload.targetMrdName,
    };
  case EDIT_HANDLERS_REQUEST:
    return {
      ...state,
      lastRequestStatus: null,
      selectedMrd: action.payload.mrdName,
    };
  case ASSOCIATE_NEW_HANDLERS_REQUEST:
    return {
      ...state,
      lastRequestStatus: null,
      selectedMrd: action.payload.mrdName,
    };
  case COPY_HANDLERS_SUCCESS:
  case ASSOCIATE_NEW_HANDLERS_SUCCESS:
  case EDIT_HANDLERS_SUCCESS:
    return {
      ...state,
      lastRequestStatus: true,
    };
  case COPY_HANDLERS_FAILURE:
  case ASSOCIATE_NEW_HANDLERS_FAILURE:
  case EDIT_HANDLERS_FAILURE:
    return {
      ...state,
      lastRequestStatus: false,
    };
  case GET_ALL_HANDLERS_SUCCESS:
    return {
      ...state,
      allHandlers: action.payload,
    };
  case GET_HANDLERS_BY_MRD_REQUEST:
    return {
      ...state,
      isHandLerListByMrdLoading: true,
    };
  case GET_HANDLERS_BY_MRD_SUCCESS:
    return {
      ...state,
      isHandLerListByMrdLoading: false,
      handlerListByMrd: action.payload,
    };
  case CLEAR_MRD_SELECTION:
    return {
      ...state,
      selectedMrd: null,
    };
  case CREATE_NEW_HANDLER_REQUEST:
    return {
      ...state,
      requestHandlerName: action.payload,
      isHandlerPersisted: false,
    };
  case CREATE_NEW_HANDLER_SUCCESS:
    return {
      ...state,
      persistedHandlerId: action.payload.handlerId,
      isHandlerPersisted: true,
    };
  case AUTH_LOGOUT:
    return initialState;
  default:
    return state;
  }
};

export default HandlersReducer;
